import * as api from "./api/index";

export async function newConversationCreationService(data, clientId) {
  const { data: res } = await api.createNewConversation(data, clientId);
  return res.data;
}

export const fetchConversationListService = async (clientId) => {
  const { data: res } = await api.fetchUserInfo(clientId);
  return res.data;
};

export async function fetchSingleConversationService(clientId, conversationId) {
  const { data: res } = await api.fetchSingleConversation(
    conversationId,
    clientId,
  );
  return res.data;
}

export const renameConversationService = async (
  clientId,
  conversationId,
  name,
) => {
  const { data: res } = await api.renameConversation(
    conversationId,
    clientId,
    name,
  );
  return res.data;
};

export const archiveConversationService = async (clientId, conversationId) => {
  const { data: res } = await api.archiveConversation(conversationId, clientId);
  return res.data;
};

export async function archiveAllConversationService(clientId) {
  const { data: res } = await api.archiveAllConversation(clientId);
  return res;
}
